module.exports = __webpack_public_path__ + "static/media/1_3.7af0086f.png";